/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import styles from '@app/components/layout/DiscoveryGuildHeader.module.css';
import guildHeaderStyles from '@app/components/layout/GuildHeader.module.css';
import {useLingui} from '@lingui/react/macro';
import {CompassIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';

export function DiscoveryGuildHeader() {
	const {t} = useLingui();

	return (
		<div
			className={clsx(guildHeaderStyles.headerContainer, guildHeaderStyles.headerContainerNoBanner)}
			style={{height: 56}}
		>
			<div className={guildHeaderStyles.headerContent} style={{cursor: 'default'}}>
				<div className={styles.headerIconContainer}>
					<CompassIcon weight="fill" className={clsx(guildHeaderStyles.verifiedIconDefault, styles.headerIcon)} />
					<span className={guildHeaderStyles.guildNameDefault}>{t`Explore`}</span>
				</div>
			</div>
		</div>
	);
}
